import { ViewModel } from "../../settings/viewModel";
import { PlotDefinition, ChartType } from "../../definitions";
import { DataProperty } from "../../library/constants";
import { HorizontalPlotter } from "./horizontalPlotter";

export class HorizontalFullScenarioPlotter extends HorizontalPlotter {
    constructor(
        viewModel: ViewModel,
        width: number,
        height: number,
        reportArea: d3.Selection<SVGElement, any, any, any>,
        svg: d3.Selection<SVGElement, any, any, any>,
        locale: string
    ) {
        super(viewModel, width, height, reportArea, svg, locale);
    }

    protected getPlotDefinition(): PlotDefinition {
        let plotDefinition = this.getBlankPlotDefinition(1);
        if (this.viewModel.hasHierarchy) {
            plotDefinition = this.getBlankPlotDefinition(0.7);
            this.addChartDefinition(
                plotDefinition,
                ChartType.Table,
                DataProperty.ReferenceValue,
                DataProperty.ReferenceValue,
                false,
                false
            );
            this.addChartDefinition(
                plotDefinition,
                ChartType.AbsoluteChart,
                DataProperty.AbsoluteDifference,
                DataProperty.ReferenceValue,
                false,
                false
            );
            this.addChartDefinition(
                plotDefinition,
                ChartType.PlusMinusDot,
                DataProperty.RelativeDifference,
                DataProperty.ReferenceValue,
                false,
                false
            );
            this.addChartDefinition(plotDefinition, ChartType.Table, DataProperty.Value, DataProperty.ReferenceValue, false, false);
            this.addChartDefinition(
                plotDefinition,
                ChartType.AbsoluteChart,
                DataProperty.SecondAbsoluteDifference,
                DataProperty.ReferenceValue,
                false,
                false
            );
            this.addChartDefinition(
                plotDefinition,
                ChartType.PlusMinusDot,
                DataProperty.SecondRelativeDifference,
                DataProperty.ReferenceValue,
                false,
                false
            );
            this.addChartDefinition(
                plotDefinition,
                ChartType.Table,
                DataProperty.SecondReferenceValue,
                DataProperty.ReferenceValue,
                false,
                false
            );
            if (this.viewModel.HasThirdReferenceColumn) {
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.AbsoluteChart,
                    DataProperty.ThirdAbsoluteDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.PlusMinusDot,
                    DataProperty.ThirdRelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.Table,
                    DataProperty.ThirdReferenceValue,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
            }
            if (this.viewModel.HasFourthReferenceColumn) {
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.AbsoluteChart,
                    DataProperty.FourthAbsoluteDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.PlusMinusDot,
                    DataProperty.FourthRelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.Table,
                    DataProperty.FourthReferenceValue,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
            }
            if (this.viewModel.HasFifthReferenceColumn) {
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.AbsoluteChart,
                    DataProperty.FifthAbsoluteDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.PlusMinusDot,
                    DataProperty.FifthRelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.Table,
                    DataProperty.FifthReferenceValue,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
            }
            if (this.viewModel.HasSixthReferenceColumn) {
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.AbsoluteChart,
                    DataProperty.SixthAbsoluteDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.PlusMinusDot,
                    DataProperty.SixthRelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.Table,
                    DataProperty.SixthReferenceValue,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
            }
            if (this.viewModel.HasSeventhReferenceColumn) {
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.AbsoluteChart,
                    DataProperty.SeventhAbsoluteDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.PlusMinusDot,
                    DataProperty.SeventhRelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.Table,
                    DataProperty.SeventhReferenceValue,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
            }
        } else {
            plotDefinition = this.getBlankPlotDefinition(0.7);
            this.addChartDefinition(plotDefinition, ChartType.ValueChart, DataProperty.Value, DataProperty.ReferenceValue, false, false);
            this.addChartDefinition(
                plotDefinition,
                ChartType.AbsoluteChart,
                DataProperty.AbsoluteDifference,
                DataProperty.ReferenceValue,
                false,
                false
            );
            this.addChartDefinition(
                plotDefinition,
                ChartType.AbsoluteChart,
                DataProperty.SecondAbsoluteDifference,
                DataProperty.ReferenceValue,
                false,
                false
            );
            if (this.viewModel.HasThirdReferenceColumn) {
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.AbsoluteChart,
                    DataProperty.ThirdAbsoluteDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
            }
            if (this.viewModel.HasFourthReferenceColumn) {
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.AbsoluteChart,
                    DataProperty.FourthAbsoluteDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
            }
            if (this.viewModel.HasFifthReferenceColumn) {
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.AbsoluteChart,
                    DataProperty.FifthAbsoluteDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
            }
            if (this.viewModel.HasSixthReferenceColumn) {
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.AbsoluteChart,
                    DataProperty.SixthAbsoluteDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
            }
            if (this.viewModel.HasSeventhReferenceColumn) {
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.AbsoluteChart,
                    DataProperty.SeventhAbsoluteDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
            }
            this.addChartDefinition(
                plotDefinition,
                ChartType.PlusMinusDot,
                DataProperty.RelativeDifference,
                DataProperty.ReferenceValue,
                false,
                false
            );
            this.addChartDefinition(
                plotDefinition,
                ChartType.PlusMinusDot,
                DataProperty.SecondRelativeDifference,
                DataProperty.ReferenceValue,
                false,
                false
            );
            if (this.viewModel.HasThirdReferenceColumn) {
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.PlusMinusDot,
                    DataProperty.ThirdRelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
            }
            if (this.viewModel.HasFourthReferenceColumn) {
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.PlusMinusDot,
                    DataProperty.FourthRelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
            }
            if (this.viewModel.HasFifthReferenceColumn) {
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.PlusMinusDot,
                    DataProperty.FifthRelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
            }
            if (this.viewModel.HasSixthReferenceColumn) {
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.PlusMinusDot,
                    DataProperty.SixthRelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
            }
            if (this.viewModel.HasSeventhReferenceColumn) {
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.PlusMinusDot,
                    DataProperty.SeventhRelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
            }
        }
        return plotDefinition;
    }
}
